import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'formatAlertTime',
  standalone: true,
})
export class FormatAlertTimePipe implements PipeTransform {
  transform(time: string): string {
    if (!time) return '';
    const date = new Date(time);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    const displayMinutes = minutes === 0 ? '' : `:${minutes.toString().padStart(2, '0')}`;
    return `${displayHours}${displayMinutes} ${ampm}`;
  }
}
